import __request__ from "routing/request";
export function update(body, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/tour/ai_report_demo_config", body, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function read(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/tour/ai_report_demo_config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
